@if (isLoading()) {
  <div class="text-center py-6"><span class="spinner-border spinner-border-sm text-primary"></span></div>
} @else if (!quizzes().length) {
  <div class="border-0 align-items-center text-center py-4 fs-5 text-muted">
    {{ "QUIZ.NONE_FOR_COURSE" | translate }}
  </div>
} @else {
  <div class="d-flex flex-column gap-3" data-testid="course-quiz-list">
    @for (quiz of quizzes(); track quiz.id) {
      <div class="d-flex flex-column flex-md-row align-items-md-center gap-3 bg-light rounded p-4">
        <div class="flex-grow-1">
          <div class="fs-5 fw-semibold">{{ quiz.title }}</div>
          <div class="fs-8 text-muted">
            {{ "QUIZ.QUESTION_COUNT" | translate }} {{ quiz.question_count }}
            · {{ "QUIZ.PASS_PERCENT" | translate }} {{ quiz.pass_percent }}%
          </div>
        </div>

        @if (best(quiz); as result) {
          <span class="badge flex-shrink-0"
                [class.badge-light-success]="result.passed" [class.badge-light-danger]="!result.passed">
            {{ result.percent }}%
          </span>
        }

        <div class="d-flex gap-2 flex-shrink-0">
          @if (best(quiz); as result) {
            <a class="btn btn-sm btn-light" [routerLink]="['/online-class/quiz/result', result.id]">
              {{ "QUIZ.VIEW_RESULT" | translate }}
            </a>
          }
          @if (!best(quiz) || quiz.allow_retake) {
            <button class="btn btn-sm btn-primary" type="button" (click)="start(quiz)">
              {{ best(quiz) ? ("QUIZ.RETAKE" | translate) : ("QUIZ.START" | translate) }}
            </button>
          }
        </div>
      </div>
    }
  </div>
}
